module.exports = "/img/28.b2627b.webp";